<template>
  <div>
    <div>
      <div style="padding: 20px;">
        <h3>{{ captainUsername !== null ? $t("drivers.captainComplaintsNoBooking.heading", { username: captainUsername }) : "" }}</h3>
      </div>

      <v-data-table :url="url" :headers="headers" :items="complaints" :pagination.sync="pagination"
        :total-items="totalItems" :rows-per-page-items="[5, 10, 15, 25, 100]" :loading="loading">
        <template v-slot:items="props">
          <tr>
            <td class="text-xs-left">{{ props.item.id }}</td>
            <td class="text-xs-left">{{ props.item.description }}</td>
            <td class="text-xs-left">{{ props.item.created_at ? moment(props.item.created_at).format("DD-MM-YYYY - HH:mm") : "-" }}</td>
            <td class="text-xs-left">{{ props.item.doer }}</td>
            <td class="text-xs-left"> <v-icon @click="showDetails(props.item)">info</v-icon></td>

          </tr>
        </template>
      </v-data-table>
    </div>

  </div>
</template>

<style lang="scss">
.reservation-position {
  width: 100%;
  max-width: 400px;
  padding: 16px 15px;
  font-size: 14px;
  border-radius: 10px;
  border: 1px solid #c1c5d8;
  background-color: #f7f8fa;
  color: #202731;
}
</style>

<script>
import LoadingComponent from "@/components/LoadingComponent";
import moment from "moment";

export default {
  name: "CaptainComplaintsNoBooking",
  title() {
    return this.$t("drivers.captainComplaintsNoBooking.title");
  },
  components: { LoadingComponent },
  data() {
    return {
      complaints: [],
      url: `captain/${this.$route.params.id}/complaint_no_booking`,
      loading: false,
      totalItems: 0,
      captainUsername: null,
      pagination: {
        sortBy: "id",
        rowsPerPage: 100,
      },
    };
  },

  computed: {
    headers() {
      return [
        { text: this.$t("drivers.captainComplaintsNoBooking.id"), value: 'id' },
        { text: this.$t("drivers.captainComplaintsNoBooking.description"), value: 'description' },
        { text: this.$t("common.date"), value: 'created_at' },
        { text: this.$t("drivers.captainComplaintsNoBooking.doer"), value: 'username' },
      ];
    },
  },
  watch: {

    pagination: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },
  methods: {
    getData() {
      this.loading = true;
      const params = new URLSearchParams();

      params.append("perPage", String(this.pagination.rowsPerPage));
      params.append("page", this.pagination.page);

      this.axios
        .get(`captain/${this.$route.params.id}/complaint_no_booking`, { params })
        .then((res) => {
          console.log(res.data.data)
          this.captainUsername = String(res.data.data.captain_username)
          this.complaints = res.data.data.data.data;
          
          this.pagination.rowsPerPage = Number(res.data.data.data.per_page);
          this.totalItems = res.data.data.data.total;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err.message);
          this.loading = false;
        });
    },
    showDetails(complaint) {
      let id=complaint.id;
      const audioPromise = this.axios.get(`complaint/${id}/audio`);
      const commentPromise = this.axios.get(`complaint_comments/${id}/get_comments`);
      Promise.allSettled([audioPromise, commentPromise]).then(([audios, comments]) => {
        complaint.audios = audios.value.data.data;
        complaint.comments = comments.value.data.data;
        complaint.comments.forEach(comment => {
          comment.audios = comment.audios.map((item) => {
            return {
              item: item,
              loading: false,
              urlObject: ''
            }
          });
        });
        this.$complaintDialog({
          complaint: complaint,
          hideCancel: true,
          fileUpload: this.$t("drivers.captainComplaintsNoBooking.soundFiles"),

          list: audios.value.data.data,
          additionalData: {
            id: id
          }
        })
      });

    },
  },
  mounted() {

  },
};
</script>
